
import HomeCard from '../HomeCard';
import style from './style.module.css';
import bg from '../../utils/bg';
import api from '../../api';
import { useState } from 'react';

const HomeInvite = props => {

    const [button, setButton] = useState('ready');

    if (!props.value) return null;

    const highlight = () => {
        if (!props.highlightValue) return null;
        const color = props.highlightColor ? (' ' + props.highlightColor) : ' home-text-secondary';
        return <div className={style.highlight + color}>XYZ group</div>
    };

    const join = async () => {
        setButton('pending');

        try {
            await api.groups.joinGroup({ group: props.value._id });
        } catch (e) {

        }

        setButton('complete');

        setTimeout(() => {
            props.onFinish();
        }, 2000);
    };

    return (
        <HomeCard title={props.title || 'Data'} icon={props.icon || ''}>
            {/* <div className={style.value + ' home-text-main'}>{props.value || ''}</div> */}
            <div className={style.info}>
                {/* <div>i</div> */}
                {/* {highlight()} */}
                {/* {JSON.stringify(props.value)} */}
                <div className={style.profile}>
                    <div className={style.photo} style={{ backgroundImage: bg.url(props.value.sender.photo) }}></div>
                    <div className={style.invite}>
                        <div className={style.highlight}>{props.value.sender.firstName} {props.value.sender.lastName}</div>
                        <div className={style.secondary + ' home-text-secondary'}>wants you to join a group</div>
                    </div>
                </div>
                <div className={style.toolbar}>
                    <div className={style.progressButton} onClick={join}>{button === 'ready' ? `Join ${props.value.name}` : (button === 'pending' ? 'Requesting...' : 'Requested to Join!')}</div>
                </div>
            </div>
            <div className={style.indicatorPrimary} />
        </HomeCard>
    );

};

export default HomeInvite;
